import styled from '@emotion/styled';
import { ImageProcessingStateWrapper } from '../../ThumbnailProcessingState';

const LoadingStateWrapper = styled(ImageProcessingStateWrapper)({
  '> div .MuiCircularProgress-root': {
    marginRight: 0,
  },
});

export default LoadingStateWrapper;
